window.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    gsap.registerPlugin(ScrollTrigger);

    let options = {
      root: null, // default is the viewport
      rootMargin: "150px", // padding of 50px to trigger the event earlier
      threshold: 0, // threshold is at 0
    };

    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        // When element is not in view
        if (!entry.isIntersecting) {
          entry.target.style.opacity = "0"; // hide the element
        } else {
          entry.target.style.opacity = "1"; // show the element
        }
      });
    }, options);

    // Start observing the element with the ID of "hero-background"
    let target = document.getElementById("hero-background");
    observer.observe(target);

    // Sticky klima device script
    gsap.to(".klima-stick", {
      scrollTrigger: {
        trigger: ".klima-stick",
        start: "top top",
        endTrigger: ".pulse-wrapper",
        end: "bottom bottom",
        pin: true,
        pinSpacing: false,
      },
      opacity: 1,
    });

    gsap.to(".klima-image", {
      scrollTrigger: {
        trigger: ".klima-showcase",
        start: "top bottom",
        end: "10%",
        scrub: true,
      },
      width: "415px",
    });

    gsap.to(".klima-device_temp", {
      scrollTrigger: {
        trigger: ".klima-showcase",
        start: "top bottom",
        end: "1%",
        scrub: true,
      },
      opacity: 0,
    });

    let media = gsap.matchMedia();
    media.add("(min-width: 768px)", () => {


      gsap.to(".klima-device_temp", {
        scrollTrigger: {
          trigger: ".klima-showcase",
          start: "top bottom",
          end: "1%",
          scrub: true,
        },
        fontSize: "70px",
        opacity: 0,
      });

    });

    media.add("(max-width: 767px)", () => {
      gsap.to(".klima-image", {
        scrollTrigger: {
          trigger: ".klima-showcase",
          start: "top bottom",
          end: "10%",
          scrub: true,
        },
        width: "250px",
      });

      const rings = gsap.utils.toArray(".ring");
      rings.forEach((ring) => {
        gsap.to(ring, {
          scrollTrigger: {
            trigger: ".klima-showcase",
            start: "top 110%",
            end: "100%",
            scrub: true,
          },
        });
      });
    });
  }, 500);
});
